export default "__VITE_ASSET__BzS3YuEt__"